import React, { useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import { GlobalStyle } from '@app/src/config/style';
import { useDispatch, useSelector } from 'react-redux';
import { isClientEnv } from '@app/src/utils/validations';
import { fetchAccess } from '@app/src/common/session';
import validExistsToken from '@app/src/utils/access';

interface Props {
  route?:any;
}

export const App: React.FC<Props> = props => {

  const isClient = isClientEnv();
  const dispatch = useDispatch();
  const appStorage = isClient && JSON.parse(localStorage.getItem('app'));
  const isToken = useSelector(state => state.session.access.isToken);

  const applyAccess = async() => {
    await dispatch(fetchAccess());
    await validExistsToken(5);
  }

  useEffect(() => {
    console.log('load initial token', isToken, appStorage);
    if (appStorage === null) {
      applyAccess();
    }
  }, []);

  return (
    <React.Fragment>
      <GlobalStyle />
      {renderRoutes(props.route.routes)}
    </React.Fragment>
  )
};
